import { Component, Input, Output, EventEmitter, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { DropdownProfile } from './dropdown-profile/dropdown-profile';
import { DropdownNotifications } from './dropdown-notifications/dropdown-notifications';
import { TasksBadge } from './tasks-badge/tasks-badge';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { DrawerModule } from 'primeng/drawer';
import { Router } from '@angular/router';
import { SelectSchoolYear } from '../../select-school-year/select-school-year';
import { HasActionDirective } from '../../../directives/has-action.directive';
import { ACTIONS } from '../../../../core/constants/actions.constants';
import { NavbarStore } from './dropdown-profile/store/navbar.store';
import { YearAcademy } from '../../../../core/services/year-academy/types';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    AvatarModule,
    MenuModule,
    BadgeModule,
    DropdownProfile,
    DropdownNotifications,
    TasksBadge,
    SidebarComponent,
    DrawerModule,
    SelectSchoolYear,
    HasActionDirective,
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  private readonly router = inject(Router);
  private readonly navbarStore = inject(NavbarStore);
  sidebarVisible = signal(false);
  ACTIONS = ACTIONS;

  constructor() {
    this.navbarStore.getYearsAcademy();
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }

  onYearChanged(year: YearAcademy): void {
    this.navbarStore.selectedYearAcademy.set(year);
  }
} 